<template>
  <div class="left" :style="styleLeft">
    <div class="fifter">
      <el-input @keyup.enter.native="filterDomain" prefix-icon="el-icon-search" v-model="filterText"
                v-show="isCollapse == false">
      </el-input>
      <el-button type="text" :title="showStatusTitle" @click="unFoldAll"
                 v-show="(showStatusTitle === $t('LanguageLib.EXPAND') ? true : false) && isCollapse == false">
        {{showStatusTitle}}
      </el-button>
      <el-button type="text" :title="showStatusTitle" @click="collapseAll"
                 v-show="(showStatusTitle === $t('LanguageLib.EXPAND') ? false : true) && isCollapse == false">
        {{showStatusTitle}}
      </el-button>
      <i class="el-icon-s-fold" style="color: #3BC6B9;padding-left: 3px;" @click="contraction(true)" v-show="isCollapse == false"></i>
      <i class="el-icon-s-unfold" style="color: #3BC6B9;padding-left: 3px;" @click="contraction(false)" v-show="isCollapse == true"></i>
    </div>
    <div class="treeBox" v-show="isCollapse == false">
      <el-tree class="filter-tree" :default-expanded-keys="oneNodeArr" :expand-on-click-node="false" @check="getCheckData" :check-strictly="!checkStrictly" :show-checkbox="showCheckBox"
               :highlight-current="true" @node-expand="changeText" @node-collapse="changeText"
               @node-click="treeNodeClick" :render-content="renderContent" :data="orgTreeData" :props="defaultProps"
               :default-expand-all="showStatus" :filter-node-method="filterNode" :current-node-key="checkDomainId"
               node-key="id" ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
import basicdataApi from '@/api/basicdata'

export default {
  name: 'DomainTree',
  props: {
    checkStrictly: Boolean, // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
    showCheckBox: Boolean, // 节点是否可被选择
    orgData: Array, // 数据源是一个list
    orgTreeData: Array, // 树状结构
    oneNodeArr: Array, // 为了做展开和收起数据字段是id的list
    checkDomainId: String // 选中id
  },
  data () {
    return {
      disabledArr: [],
      filterText: '',
      renderContent: function (h, { node, data }) {
        var openidstr = node.label.slice(0, 3)
        if (openidstr === 'wx|' && JSON.parse(this.$commonfun.localStorage.getitem('qyuser'))) {
          return <ww-open-data
            style="height:20px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(96,98,102,1);line-height:20px;"
            type="departmentName" openid={node.label.slice(3)}></ww-open-data>
        } else {
          return <span
            style="height:20px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(96,98,102,1);line-height:20px;">{node.label}</span>
        }
      },
      showStatus: false, // 组织树默认收起
      isCollapse: false, // 显示隐藏组织树
      styleLeft: 'width: 20%', // left默认宽度
      showStatusTitle: this.$t('LanguageLib.COLLAPSE'),
      searchTreeIds: [], // 通过接口获取企微id
      defaultProps: {
        children: 'childDomainTrees',
        label: 'domainName'
      }
    }
  },
  methods: {
    filterDomain () {
      if (this.$commonfun.localStorage.getitem('qyuser') === 'true') {
        basicdataApi.getSearchName('post', '/QYUser/Search',
          {
            ownerId: this.$commonfun.localStorage.getitem('ownerId'),
            ownerCode: this.$commonfun.localStorage.getitem('ownerCode'),
            search: this.filterText,
            queryType: 2
          }, 'Api')
          .then(res => {
            this.searchTreeIds = res.data
            this.$refs.tree.filter(this.filterText)
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.searchTreeIds = []
        this.$refs.tree.filter(this.filterText)
      }
    },
    filterNode (value, data) {
      if (!value) {
        return true
      } else {
        if (value.slice(0, 3) === 'wx|') {
          return false
        } else {
          return (data.domainName.indexOf(value) !== -1 && data.domainName.indexOf('wx|') === -1) || this.$commonfun.IsInArray(this.searchTreeIds, data.id)
        }
      }
    },
    // 全部展开
    unFoldAll () {
      const self = this
      // 将没有转换成树的原数据
      const treeList = this.orgData
      for (let i = 0; i < treeList.length; i++) {
        // 将没有转换成树的原数据设置key为... 的展开
        if (self.$refs.tree.store.nodesMap[treeList[i].id]) {
          self.$refs.tree.store.nodesMap[treeList[i].id].expanded = true
        }
      }
      // 将文本变成一键收起
      this.showStatusTitle = this.$t('LanguageLib.COLLAPSE')
    },
    // 全部折叠
    collapseAll () {
      const self = this
      const treeList = this.orgData
      for (let i = 0; i < treeList.length; i++) {
        if (self.$refs.tree.store.nodesMap[treeList[i].id]) {
          self.$refs.tree.store.nodesMap[treeList[i].id].expanded = false
        }
      }
      // 将文本变成一键展开
      this.showStatusTitle = this.$t('LanguageLib.EXPAND')
    },
    // 显示隐藏组织树
    contraction (type) {
      this.isCollapse = type
      if (type === true) {
        this.styleLeft = 'width: 25px;transition: width .28s;'
      } else {
        this.styleLeft = 'width: 20%;transition: width .28s;'
      }
      this.$emit('isCollapse-treedata', type)
    },
    // 树节点点击
    treeNodeClick (data, node, item) {
      // 自定义一个事件addcheck-treedata 为了拿{ domainName: data.domainName, id: data.id, domainNo: data.domainNo }数据
      this.$emit('addcheck-treedata', {
        domainName: data.domainName,
        id: data.id,
        domainNo: data.domainNo
      })
    },
    setCheckData (data) {
      this.$refs.tree.setCheckedKeys(data, true)
    },
    getCheckData () {
      const checkArr = this.$refs.tree.getCheckedNodes()
      // 禁用数组置为空
      this.disabledArr = []
      for (var i in checkArr) {
        if (checkArr[i].childDomainTrees) {
          this.getdisabledArr(checkArr[i].childDomainTrees)
        }
      }
      this.dealTreeOnceChecked(this.orgTreeData)
      this.$emit('getCheckedData', this.$refs.tree.getCheckedNodes())
    },
    getdisabledArr (arrMenus) {
      if (arrMenus.length > 0) {
        arrMenus.forEach(item => {
          const arrChildren = item.childDomainTrees
          if (arrChildren) {
            this.getdisabledArr(arrChildren)
          }
          this.disabledArr.push(item.id)
          this.$refs.tree.setChecked(item.id, false)
        })
      }
    },
    dealTreeOnceChecked (data) {
      if (data.length > 0) {
        data.forEach(item => {
          const arrChildren = item.childDomainTrees
          if (arrChildren) {
            this.dealTreeOnceChecked(arrChildren)
          }
          if (this.disabledArr.indexOf(item.id) >= 0) {
            this.$set(item, 'disabled', true)
            item.disabled = true
          } else {
            this.$set(item, 'disabled', false)
            item.disabled = false
          }
        })
      }
    },

    changeText (data, node, item) {
      setTimeout(() => {
        const treeList = this.orgData
        // 定义一个变量为收起节点的数量
        var num = 0
        var delnum = 0
        for (let i = 0; i < treeList.length; i++) {
          if (this.$refs.tree.store.nodesMap[treeList[i].id]) {
            if (this.$refs.tree.store.nodesMap[treeList[i].id].expanded) {
              this.showStatusTitle = this.$t('LanguageLib.COLLAPSE')
            } else {
              num++
            }
          } else {
            delnum++
          }
        }
        // 收起节点的数量与数据长度相等改变文字
        if ((num + delnum) === treeList.length) {
          this.showStatusTitle = this.$t('LanguageLib.EXPAND')
        }
      }, 100)
    }
  }
}
</script>

<style lang="scss">
.selectOrgBox {
  .left {
    background: #fff;
    width: 320px;
    height: 535px;
    border: 1px solid #f2f2f2;

    .fifter {
      height: 30px;
      padding: 10px 0 10px 20px;
      margin: 0 auto;
      border-bottom: 1px solid #f2f2f2;

      .el-input {
        width: 220px;

        input {
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }

        .el-icon-search {
          line-height: 30px;
        }
      }

      .el-button--text {
        margin-left: 8px;
        padding: 7px 0;
        color: #3BC6B9;
      }
    }

    .treeBox {
      height: calc(100% - 51px);
      overflow: auto;
      width: 320px;
    }

    .treeBox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .treeBox::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .treeBox::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
  }
}
</style>
